// NGRX
import { createFeatureSelector, createSelector } from "@ngrx/store";
// Lodash
import { each } from "lodash";
// CRUD
import { HttpExtenstionsModel, QueryResultsModel } from "../_base/crud";
import { PromotionModel } from "./promotion.model";
// State
import { PromotionsState } from "./promotions.reducers";

export const selectPromotionsState = createFeatureSelector<PromotionsState>("promotions");

export const selectPromotionById = (promotionId: number) =>
  createSelector(selectPromotionsState, (promotionsState) => promotionsState.entities[promotionId]);

export const selectPromotionsPageLoading = createSelector(
  selectPromotionsState,
  (promotionsState) => promotionsState.listLoading
);

export const selectPromotionsActionLoading = createSelector(
  selectPromotionsState,
  (customersState) => customersState.actionsloading
);

export const selectPromotionsPageLastQuery = createSelector(
  selectPromotionsState,
  (promotionsState) => promotionsState.lastQuery
);

export const selectLastCreatedPromotionId = createSelector(
  selectPromotionsState,
  (promotionsState) => promotionsState.lastCreatedPromotionId
);

export const selectPromotionsInitWaitingMessage = createSelector(
  selectPromotionsState,
  (promotionsState) => promotionsState.showInitWaitingMessage
);

export const selectPromotionsInStore = createSelector(selectPromotionsState, (promotionsState) => {
  const items: PromotionModel[] = [];
  each(promotionsState.entities, (element) => {
    items.push(element);
  });
  const httpExtension = new HttpExtenstionsModel();
  const result: PromotionModel[] = httpExtension.sortArray(
    items,
    promotionsState.lastQuery.sortField,
    promotionsState.lastQuery.sortOrder
  );
  return new QueryResultsModel(result, promotionsState.totalCount, "");
});

export const selectHasPromotionsInStore = createSelector(selectPromotionsInStore, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
